/**
 * 邀请函页盘古 API / CRM 前端域名配置
 */
import axios from "axios";
import { Toast } from "vant";

const host = window.location.host;

export const getPanguBaseUrl = () => {
  if (host.indexOf("exp4pad-test.classba.cn") > -1) {
    return "https://api-pangu-test.songshuai.com/pangu";
  }
  if (host.indexOf("exp4pad-pre.classba.cn") > -1) {
    return "https://api-pangu-pre.songshuai.com/pangu";
  }
  if (host.indexOf("exp4pad.classba.cn") > -1) {
    return "https://api-pangu.songshuai.com/pangu";
  }
  if (process.env.VUE_APP_PANGU_API_URL) {
    return process.env.VUE_APP_PANGU_API_URL.replace(/\/$/, "");
  }
  return "https://api-pangu-test.songshuai.com/pangu";
};

/** 签到二维码跳转的 CRM 前端域名 */
export const getCrmUrl = () => {
  if (
    host.indexOf("exp4pad-test.classba.cn") > -1 ||
    host.indexOf("localhost") > -1 ||
    process.env.VUE_APP_ENV === "development" ||
    process.env.VUE_APP_ENV === "test"
  ) {
    return "https://pangu.myyixue.com";
  }
  if (host.indexOf("exp4pad-pre.classba.cn") > -1) {
    return "https://pangu.songshuai.com";
  }
  return "https://pangu.songshuai.com";
};

const service = axios.create({
  baseURL: getPanguBaseUrl(),
  withCredentials: false,
  timeout: 30 * 1000,
  headers: {
    "Content-Type": "application/json; charset=UTF-8",
  },
});

service.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("APP_TOKEN");
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    Toast("系统开小差了，刷新后再试");
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    const data = response.data || {};
    if (
      data.status !== undefined
      && data.status !== 0
      && !response.config.silentError
    ) {
      Toast({
        message: data.info || data.message || "请求失败",
        duration: 3000,
      });
    }
    return data;
  },
  (error) => {
    if (
      error.code === "ECONNABORTED" ||
      (error.message && error.message.indexOf("timeout") > -1)
    ) {
      Toast({
        message: "当前网络环境差，请稍后再试",
        duration: 3000,
      });
    } else if (!error.config || !error.config.silentError) {
      Toast({
        message: error.message || "接口请求失败",
        duration: 3000,
      });
    }
    return Promise.reject(error);
  }
);

export const get = (url, params = {}) =>
  service.request({ url, method: "get", params });

export const post = (url, data = {}, config = {}) =>
  service.request({ url, method: "post", data, ...config });

export const uploadFile = (url, formData) =>
  service.request({
    url,
    method: "post",
    data: formData,
    transformRequest: [
      (data, headers) => {
        if (headers && headers.post) {
          delete headers.post["Content-Type"];
        }
        delete headers["Content-Type"];
        return data;
      },
    ],
  });
